import { render, staticRenderFns } from "./Scene22.vue?vue&type=template&id=25056206&scoped=true"
import script from "./Scene22.vue?vue&type=script&lang=js"
export * from "./Scene22.vue?vue&type=script&lang=js"
import style0 from "./Scene22.vue?vue&type=style&index=0&id=25056206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25056206",
  null
  
)

export default component.exports